import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const FeatureContext = createContext();

export const useFeatures = () => {
  const context = useContext(FeatureContext);
  if (!context) {
    throw new Error('useFeatures must be used within a FeatureProvider');
  }
  return context;
};

export const FeatureProvider = ({ children }) => {
  const { user, token } = useAuth();
  const [features, setFeatures] = useState({
    fca_enabled: true,
    building_inspections_enabled: false,
    iwms_enabled: false,
    damage_triage_enabled: false,
    project_management_enabled: false,
    procurement_planner_enabled: false,
    drawing_intel_enabled: false,
    is_admin: false
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeatures = async () => {
      if (!token || !user) {
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${API_URL}/api/features/my-features`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          const data = await response.json();
          setFeatures(data);
        }
      } catch (error) {
        console.error('Error fetching features:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFeatures();
  }, [token, user]);

  const refreshFeatures = async () => {
    if (!token) return;

    try {
      const response = await fetch(`${API_URL}/api/features/my-features`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setFeatures(data);
      }
    } catch (error) {
      console.error('Error refreshing features:', error);
    }
  };

  return (
    <FeatureContext.Provider value={{ features, loading, refreshFeatures }}>
      {children}
    </FeatureContext.Provider>
  );
};
